var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E1EAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F7F9FD",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22866_22274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4697 27.4819H11.089C10.338 27.4819 9.71313 26.9003 9.67948 26.15C9.60391 24.4656 9.60624 22.8008 9.68645 21.115C9.71907 20.4296 10.2481 19.8698 10.9321 19.8147C12.1006 19.7205 13.1242 19.7205 14.2927 19.8147C14.9768 19.8698 15.5058 20.4296 15.5384 21.115C15.6397 23.2435 15.6168 25.3385 15.4697 27.4819Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4463 27.4818H15.7317C15.5732 23.677 15.5589 19.9648 15.6889 16.1766C15.7116 15.5168 16.1873 14.9539 16.8414 14.8642C18.0605 14.697 19.1174 14.697 20.3366 14.8642C20.9907 14.9539 21.4664 15.5168 21.489 16.1766C21.619 19.9648 21.6048 23.677 21.4463 27.4818Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9804 27.4819H21.636C21.4762 23.6435 21.4631 15.5885 21.5968 11.0598C21.6163 10.3999 22.0917 9.83987 22.7458 9.75016C23.9649 9.58295 25.0218 9.58295 26.2409 9.75016C26.8951 9.83987 27.3705 10.3999 27.3899 11.0598C27.5094 15.1038 27.5116 21.9594 27.3969 26.1138C27.3758 26.8793 26.7462 27.4819 25.9804 27.4819Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4697 27.4817H11.089C10.338 27.4817 9.71313 26.9003 9.67948 26.15C9.60391 24.4655 9.60624 22.8007 9.68645 21.1149C9.71907 20.4295 10.2481 19.8697 10.9321 19.8146C12.1006 19.7204 13.1242 19.7204 14.2927 19.8146C14.9768 19.8697 15.5058 20.4295 15.5384 21.1149C15.6397 23.2433 15.6168 25.3383 15.4697 27.4817Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4463 27.4819H15.7317C15.5732 23.677 15.5589 19.9649 15.6889 16.1767C15.7116 15.5169 16.1873 14.954 16.8414 14.8643C18.0606 14.6971 19.1174 14.6971 20.3366 14.8643C20.9907 14.954 21.4664 15.5169 21.489 16.1767C21.619 19.9649 21.6048 23.677 21.4463 27.4819Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9804 27.4819H21.636C21.4762 23.6435 21.4631 15.5885 21.5968 11.0598C21.6163 10.3999 22.0917 9.83987 22.7458 9.75016C23.9649 9.58295 25.0218 9.58295 26.2409 9.75016C26.8951 9.83987 27.3705 10.3999 27.3899 11.0598C27.5094 15.1038 27.5116 21.9594 27.3969 26.1138C27.3758 26.8793 26.7462 27.4819 25.9804 27.4819Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22866_22274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.55307 8.55331)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIcon);
export default __webpack_public_path__ + "static/media/poll_icon.dd90172a727a0b0effb54abdd723fd36.svg";
export { ForwardRef as ReactComponent };